import { useContext, useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { ConfigContext } from '../../../../../Contexts/ConfigContext';
import FormatDataConstants from '../constants.json';
import useStyles from './styles.js';
import DropDownSingle from '../../../../../Components/DropDownSingle';
import { getPercentageValue } from '../../../../../utilities/helpers.js';

const OverlayClickBlockerPreview = ({ keyData }) => {
	const { DEFAULT_VALUES, MAX_HEIGHT, MAX_WIDTH, PLATFORMS } =
		FormatDataConstants.OVERLAY_CLICK_BLOCKER;

	const classes = useStyles();

	const { rawConfig } = useContext(ConfigContext);

	const [overlayClickBlockerPreviewPlatform, setOverlayClickBlockerPreviewPlatform] = useState(
		PLATFORMS[0]
	);
	const [floatingPlayerSizes, setFloatingPlayerSizes] = useState({});

	useEffect(() => {
		const width = Math.min(
			Number(
				rawConfig[`formatData.floatingPlayerSizes.${overlayClickBlockerPreviewPlatform}.width`]
			),
			MAX_WIDTH
		);
		const height = Math.min(
			Number(
				rawConfig[`formatData.floatingPlayerSizes.${overlayClickBlockerPreviewPlatform}.height`]
			),
			MAX_HEIGHT
		);

		setFloatingPlayerSizes({ width, height });
	}, [rawConfig, overlayClickBlockerPreviewPlatform]);

	if (!rawConfig[keyData + '.enabled']) return null;

	const borderWidthPercentage = getPercentageValue(
		rawConfig,
		`${keyData}.widthPercentage`,
		DEFAULT_VALUES.WIDTH_PERCENTAGE
	);

	const topLengthPercentage = getPercentageValue(
		rawConfig,
		`${keyData}.topLengthPercentage`,
		DEFAULT_VALUES.TOP_LENGTH_PERCENTAGE
	);

	const leftHeightPercentage = getPercentageValue(
		rawConfig,
		`${keyData}.leftHeightPercentage`,
		DEFAULT_VALUES.LEFT_HEIGHT_PERCENTAGE
	);

	const rightHeightPercentage = getPercentageValue(
		rawConfig,
		`${keyData}.rightHeightPercentage`,
		DEFAULT_VALUES.RIGHT_HEIGHT_PERCENTAGE
	);
	const handlePlatformChange = (value) => {
		setOverlayClickBlockerPreviewPlatform(value);
	};

	return (
		<Grid
			container
			spacing={4}
			className={classes.overlayClickBlockerPreview}
			sx={{ marginTop: '2rem', minHeight: '40rem' }}
		>
			<Grid
				item
				xs={12}
				md={4}
				sx={{
					display: 'flex',
					flexDirection: 'column',
					gap: '2rem'
				}}
			>
				<Typography variant="h6" sx={{ fontWeight: 600 }}>
					Overlay Click Blocker Preview
				</Typography>

				<DropDownSingle
					isObjectEditor={false}
					label="Platform"
					list={PLATFORMS}
					directValue={overlayClickBlockerPreviewPlatform}
					updateDirectValue={handlePlatformChange}
					formControlStyles={{ width: '100%' }}
					formControlVariant="outlined"
					containerStyles={{ width: '100%' }}
				/>
			</Grid>

			<Grid
				item
				xs={12}
				md={7}
				sx={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					transition: 'all 0.3s ease'
				}}
			>
				{floatingPlayerSizes.width && floatingPlayerSizes.height ? (
					<Box
						className={classes.playerPreviewBox}
						sx={{
							width: `${floatingPlayerSizes.width}px`,
							height: `${floatingPlayerSizes.height}px`,
							overflow: 'hidden'
						}}
					>
						<Box
							className={classes.topOverlay}
							sx={{
								width: `${(floatingPlayerSizes.width * topLengthPercentage) / 100}px`,
								height: `${(floatingPlayerSizes.height * borderWidthPercentage) / 100}px`
							}}
						/>
						<Box
							className={classes.leftOverlay}
							sx={{
								width: `${(floatingPlayerSizes.width * borderWidthPercentage) / 100}px`,
								height: `${(floatingPlayerSizes.height * leftHeightPercentage) / 100}px`
							}}
						/>
						<Box
							className={classes.rightOverlay}
							sx={{
								width: `${(floatingPlayerSizes.width * borderWidthPercentage) / 100}px`,
								height: `${(floatingPlayerSizes.height * rightHeightPercentage) / 100}px`
							}}
						/>
					</Box>
				) : (
					<Typography variant="h6" sx={{ fontWeight: 600 }}>
						{`Please configure a valid floating player width and height for the ${overlayClickBlockerPreviewPlatform} platform under the "Format Data > Player Sizes".`}
					</Typography>
				)}
			</Grid>
		</Grid>
	);
};

export default OverlayClickBlockerPreview;
